export enum QueryParameter {
    AppId = 'ap',
    AssetId = 'ai',
    ClientId = 'c',
    CollectionId = 'ci',
    Configure = 'cf',
    /**
     * @deprecated Use `FilterTemplateCategories` instead.
     * This needs to be kept around to support old links.
     */
    FilterCategory = 'fc',
    /**
     * This was previously `ff` as the filter was named "Formats" however the name of the filter changed to "Dimensions"
     * and therefore we want to update the param to use `fd` instead.
     */
    FilterFormat = 'fd',
    /**
     * This is the new param for the platform filter, this was previously associated with "FilterFormat" however
     * the name of the filter changed to "Dimensions" and the platform filter is now named "Formats".
     * This is also the param passed from the legacy page to the new gallery page.
     */
    FilterPlatform = 'ff',
    FilterSearchTerm = 'fst',
    FilterStatus = 'fs',
    FilterTab = 'tb',
    FilterTags = 'ft',
    /**
     * This is the new param for the category filter, this was previously "FilterCategory" however
     * the format of the id for FilterTemplateCategories is different from the new category filter and thus
     * existing links will break if we don't create a new param for it and support both.
     */
    FilterTemplateCategories = 'ftc',
    FolderId = 'f',
    LocationId = 'l',
    LocationName = 'ln',
    NewSettingsPanel = 'nsp',
    NewTemplate = 'nt',
    Origin = 'o',
    PlannerId = 'p',
    PlatformName = 'pn',
    RedirectPath = 'rp',
    ScheduledPlatform = 'sp',
    ScheduledTab = 'st',
    ScheduleFlowId = 'sf',
    SortBy = 'sb',
    TemplateContentBuildId = 'tcb',
    TemplateId = 't',
    TemplateVersionId = 'tv',
}
